import { publish } from './scripts/publish';
import { subscribe } from './scripts/subscribe';
import { unsubscribe } from './scripts/unsubscribe';
(function init() {
    if (typeof window === 'undefined') {
        return;
    }
    require('custom-event-polyfill');
    if (!window.StStCustomEventsStore) {
        window.StStCustomEventsStore = {};
    }
    if (!window.StStEvents) {
        window.StStEvents = {
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            publish: publish,
        };
    }
})();
export { subscribe, unsubscribe, publish };
export { EVENT_TYPES } from './eventTypes';
//# sourceMappingURL=index.js.map